<template>
    <div class="relative">
        <span class="inline-block max-w-xl text-sm truncate">
            {{ modelValue }}
        </span>

        <div v-if="props.valid" class="absolute text-green-800 -translate-y-1/2 top-1/2 right-4">
            <icon icon="hero/outline/check" class="w-4 h-4"></icon>
        </div>

        <div v-if="props.invalid" class="absolute text-red-800 -translate-y-1/2 top-1/2 right-4">
            <icon icon="hero/outline/exclamation-circle" class="w-4 h-4"></icon>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ComponentSize } from '@src/Common/DataGrid/types';

defineOptions({
    inheritAttrs: false,
});

const modelValue = defineModel<string | number | undefined>();

interface Props {
    placeholder?: string | undefined;
    size?: ComponentSize;
    dusk?: string | null;
    valid?: boolean;
    invalid?: boolean;
    required?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    placeholder: undefined,
    size: 'base',
    dusk: null,
    valid: false,
    invalid: false,
});
</script>
